import type { GamePhase, GameState } from "../types";

export function resolvePhase(state: Pick<GameState, "progress" | "loopCount" | "requiredProgress">): GamePhase {
  if (state.progress >= state.requiredProgress) return "final";
  if (state.loopCount >= 3 && state.progress <= 2) return "player_contact";
  if (state.progress >= 7) return "record_corruption";
  if (state.progress >= 5) return "retired_contact";
  if (state.progress >= 3) return "retired_hint";
  if (state.progress >= 1 || state.loopCount > 0) return "early";
  return "tutorial";
}

export function getAnomalyProbability(phase: GamePhase): number {
  switch (phase) {
    case "tutorial": return 0;
    case "early": return 0.45;
    case "retired_hint": return 0.52;
    case "retired_contact": return 0.58;
    case "record_corruption": return 0.62;
    case "player_contact": return 0.65;
    case "final": return 1;
    case "ending": return 0;
  }
}

export function displayClock(state: Pick<GameState, "currentMailIndex" | "loopCount" | "progress">): string {
  const baseMinutes = 23 * 60 + 40;
  const elapsed = state.currentMailIndex * 13 + state.progress * 3;
  const rewind = Math.min(state.loopCount, 5) * 7;
  const total = (baseMinutes + elapsed - rewind) % (24 * 60);
  const hour = Math.floor(total / 60).toString().padStart(2, "0");
  const minute = (total % 60).toString().padStart(2, "0");
  return `${hour}:${minute}`;
}
